import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { apiPost } from '../../framework/client';

export async function postSendSmartFleetTaskEmail(
    customerId: string,
    vehicleContractId: string | null,
    email: string,
    taskType: string,
    locale: 'en' | 'fi',
): Promise<any> {
    const response = await apiPost(`/api/admin/send-reminder`, {
        customerId,
        vehicleContractId,
        email,
        taskType,
        locale,
    });

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
